
export type MarkNotificationAsDelivered200Target = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
